import { Chip, Typography } from '@mui/material';
import FlowResourceDisplay from '../flows/FlowResourceDisplay';
import { Link, colors } from '../../utils/theme';
import FlowRunDisplay from '../flows/FlowRunDisplay';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CronTableCellDisplay from '../flows/CronTableCellDisplay';

const IdentifierCell = ({
  params,
  direction,
}: {
  params: any;
  direction: 'source' | 'destination';
}) => {
  let jsonIds = [];
  // @ts-ignore
  try {
    jsonIds = JSON.parse(params.value);
    // @ts-check
  } catch (e) {
    jsonIds = [];
  }

  // find the img_url, type_name, and web_url in params.row
  const row = params.row;
  // find the img_url, type_name, and web_url nested in the row wheteher it is source or destination
  const img_url =
    direction === 'source' ? row?.source?.img_url : row?.destination?.img_url;
  const type_name =
    direction === 'source'
      ? row?.source?.type_name
      : row?.destination?.type_name;
  const web_url =
    direction === 'source' ? row?.source_web_url : row?.destination_web_url;

  return (
    <span>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {img_url && (
          <img
            src={img_url}
            alt={type_name}
            style={{
              maxHeight: '24px',
              maxWidth: '48px',
              paddingRight: `8px`,
            }}
          />
        )}
        <Typography
          variant={'overline'}
          color="inherit"
          noWrap={true}
          sx={{ width: '100%', textTransform: 'capitalize' }}
        >
          {type_name}
        </Typography>
      </div>
      <small
        style={{
          // backgroundColor: colors.grey[100],
          // marginTop: '4px',
          padding: '4px',
          // borderRadius: '4px',
          display: 'block',
        }}
      >
        {jsonIds.map((x: any) => {
          if (x?.is_link) {
            return (
              <Link
                to={web_url}
                target="_blank"
                style={{ textDecoration: 'underline' }}
              >
                <strong>{x?.title}</strong>: {x?.value}{' '}
                <OpenInNewIcon
                  fontSize={'small'}
                  sx={{ verticalAlign: 'middle', ml: 0.5, fontSize: '14px' }}
                />
              </Link>
            );
          }
          return (
            <div>
              <strong>{x.title}</strong>: {x.value}
              <br />
            </div>
          );
        })}
      </small>
    </span>
  );
};

const severityColorMap = {
  error: colors.error.main,
  warn: colors.warning.light,
  pass: colors.success.light,
};

const ValidationsColDefs = (currentAccount: any, settings: any) => [
  {
    field: 'severity',
    headerName: 'Severity',
    width: 80,
    sortable: false,
    type: 'singleSelect',
    valueOptions: ['error', 'pass', 'warn'],
    filterable: true, // Enable filtering on severity
    // @ts-ignore
    groupingValueGetter: (groupingData) => groupingData,
    // @ts-ignore
    renderCell: (params) => (
      // <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <Chip
        // @ts-ignore
        sx={{
          textTransform: 'capitalize',
          // @ts-ignore
          backgroundColor: severityColorMap[params.value],
          color: colors.common.white,
          margin: '0 auto',
        }}
        label={params.value}
      />
      // </div>
    ),
  },
  {
    field: 'title',
    headerName: 'Issue',
    flex: 1.25,
    sortable: false,
    filterable: false,
    // @ts-ignore
    renderCell: (params) => (
      <div>
        <Typography
          // sx={{ paddingTop: 1 }}
          variant="body2"
          fontWeight={'bold'}
          color="initial"
        >
          {params.value}
        </Typography>
        <Typography variant="caption" sx={{ paddingTop: 1 }} color="initial">
          {params.row.detail}
        </Typography>
      </div>
    ),
  },

  {
    field: 'source_identifiers',
    headerName: 'Source',
    flex: 1.25,
    renderCell: (params: any) => {
      return <IdentifierCell direction="source" params={params} />;
    },
    sortable: false,
    filterable: false,
  },
  {
    field: 'destination_identifiers',
    headerName: 'Destination',
    flex: 1.25,
    renderCell: (params: any) => {
      return <IdentifierCell direction="destination" params={params} />;
    },
    sortable: false,
    filterable: false,
  },
  {
    // @ts-ignore
    field: 'next_run',
    headerName: 'Next Sync',
    flex: 1,
    filterable: false,
    renderCell: (params: any) => {
      const flowSchedules = params.row?.flow_entity?.['schedule'];

      // group by schedule.schedule
      const groupedSchedules = flowSchedules?.reduce(
        (acc: any, schedule: any) => {
          // if (!schedule.enabled) return acc;
          acc[schedule.schedule] = acc[schedule.schedule] || [];
          acc[schedule.schedule].push(schedule);
          return acc;
        },
        {},
      );

      return (
        <div>
          {params.row.flow_entity?.['next-run'] ? (
            <Link
              to={`/${currentAccount.name}/flows/${params.row.flow_entity.name}?highlightCol=id&highlightVal=${params.row.flow_entity?.['next-run'].id}`}
            >
              <FlowRunDisplay
                timezone={settings.timeZone.current}
                nextOrLastRun={'next'}
                // @ts-ignore
                flowRun={params.row.flow_entity?.['next-run']}
              />
            </Link>
          ) : (
            Object.keys(groupedSchedules || {}).map((schedule: any) => (
              <CronTableCellDisplay
                sx={{ fontSize: 'small' }}
                params={{ value: { schedule } }}
              />
            ))
          )}
        </div>
      );
    },
  },
  {
    // @ts-ignore
    field: 'last_run',
    headerName: 'Last Sync',
    flex: 1,
    filterable: false,
    renderCell: (params: any) => {
      return (
        <div>
          {params.row.flow_entity?.['last-run'] && (
            <Link
              to={`/${currentAccount.name}/flows/${params.row.flow_entity.name}?highlightCol=id&highlightVal=${params.row.flow_entity?.['last-run'].id}`}
            >
              <FlowRunDisplay
                timezone={settings.timeZone.current}
                nextOrLastRun={'last'}
                // @ts-ignore
                flowRun={params.row.flow_entity?.['last-run']}
              />
            </Link>
          )}
        </div>
      );
    },
  },
];

export default ValidationsColDefs;
